import { AxiosInstance } from 'axios'

import { OrganisationExtended } from '../nonprofits/nonprofitsService.types'

import { Money } from '@percent/utility'

export type DonationServiceCapabilities = {
  percentClient: AxiosInstance
}

export enum DonationListStatusFilterEnum {
  Active = 'ACTIVE',
  ReceivedPayment = 'RECEIVED_PAYMENT',
  Settled = 'SETTLED',
  Disbursed = 'DISBURSED',
  Cancelled = 'CANCELLED',
  RequestedPayment = 'REQUESTED_PAYMENT',
  CheckSent = 'CHECK_SENT'
}

export enum DonationType {
  Wallet = 'wallet',
  Hosted = 'hosted',
  Matched = 'matched',
  Direct = 'direct',
  External = 'external',
  Payroll = 'payroll'
}

export enum DisbursementKind {
  ApprovalRequired = 'approval_required',
  Approved = 'approved',
  InTransit = 'in_transit',
  Paid = 'paid',
  Cancelled = 'cancelled'
}

export enum DisbursementType {
  Cheque = 'cheque',
  Card = 'card',
  BankTransfer = 'bank_transfer'
}

export type WalletFundingSource = {
  id: string | null
  name: string | null
  amount: Money
}

export type Donation = {
  amount: number
  anonymous: boolean | null
  cancelledAt: string | null
  consentedToBeContactedByOrg: boolean | null
  createdAt: string
  currencyCode: string
  email?: string | null
  firstName?: string | null
  giftAidId: string | null
  id: string
  lastName?: string | null
  metadata: string | null
  organisationId: string | null
  status: DonationListStatusFilterEnum
  type: DonationType
  userId: string
  organisation: OrganisationExtended
  accountId?: string
  donationRequestAmount: Money
  disbursedAt: Date | null
  disbursement: {
    id: string
    disbursementType: DisbursementType
    disbursementKind: DisbursementKind
    createdAt: Date
    updatedAt: Date | null
    inTransitAt: Date | null
  } | null
  category: DonationCategory
  walletFundingSources: WalletFundingSource[] | null
  giftNote?: string
}

export type GetDonationsListProps = {
  pageSize?: number | null
  startDate?: string | null
  endDate?: string | null
  status?: string[] | null
  fundraiserId?: string | null
  kinds?: string[] | null
  category?: string[] | null
  query?: string | null
  'expand[]'?: string
  excludeImported?: boolean
}

export type DonationCategory = 'grant' | 'employee_impact' | 'consumer_giving' | 'corporate_donation' | 'unclassified'

export type CreateDonationRequest = {
  amount: number
  currencyCode: string
  organisationId: string
  subsidiaryId?: string
  metadata?: {
    costCenter?: string
    [key: string]: unknown
  }
  giftNote?: string
  category?: DonationCategory
}

export type DonationPartnerConfigSupportedCurrencies = {
  partnerId: string
  key: 'supported_currencies'
  value: string[] // ISO 4217 currency codes
  createdAt: string
}

export type DonationPartnerConfigResponse = {
  object: 'donation_partner_config'
  data: {
    supported_currencies?: DonationPartnerConfigSupportedCurrencies
  }
}
